import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

// PWA install prompt — shown once (dismissable, remembered in localStorage).
// Triggered by the browser's `beforeinstallprompt` event on supported devices.
const STORAGE_KEY = "erp_pwa_dismissed_at";

export default function PWAInstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY);
    if (dismissed) {
      const age = Date.now() - parseInt(dismissed, 10);
      // Show again after 7 days
      if (age < 7 * 86400000) return;
    }
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    // Also detect if already running as installed PWA
    if (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) {
      setVisible(false);
    }
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const choice = await deferred.userChoice;
    setVisible(false);
    setDeferred(null);
    if (choice.outcome !== "accepted") {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    }
  };
  const dismiss = () => {
    setVisible(false);
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
  };

  if (!visible) return null;
  return (
    <div className="fixed bottom-4 right-4 z-50 bg-gradient-to-r from-indigo-600 to-violet-600 text-white rounded-xl shadow-2xl px-4 py-3 flex items-center gap-3 max-w-sm animate-in fade-in slide-in-from-bottom-4" data-testid="pwa-install-prompt">
      <div className="bg-white/20 rounded-lg p-2"><Download size={18}/></div>
      <div className="flex-1">
        <div className="text-sm font-semibold">CustomerERP'yi Yükleyin</div>
        <div className="text-[11px] opacity-90">Ana ekrana ekleyin — tabletinizde/telefonunuzda tam ekran açılır, offline erişim sağlar.</div>
      </div>
      <button onClick={install} className="bg-white text-indigo-700 text-xs font-semibold px-3 py-1.5 rounded shadow hover:bg-slate-50" data-testid="pwa-install-btn">Yükle</button>
      <button onClick={dismiss} className="text-white/70 hover:text-white p-1" data-testid="pwa-dismiss-btn"><X size={14}/></button>
    </div>
  );
}
